import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appointableQueryKeys } from "./appointableQueryKeys";

export function useAppointableCategoryDisable({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) => {
      return (await api.appointableApi.disableCategory(id)).data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: appointableQueryKeys.categoriesAll(),
      });
    },
  });
}
